import * as yup from 'yup';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';

// eslint-disable-next-line import/prefer-default-export
export const smartLockScheduledCodeSchema = yup.object().shape({
  code: yup.string().required('Code is required').matches(/^\d+$/, 'code must be a number'),
  name: yup.string().required('Name is required'),
  scheduled_on: yup
    .string()
    .required('Scheduled on is required')
    .test(
      'min-10-minutes',
      'Scheduled time must be at least 10 minutes from now',
      (value) => {
        if (!value) {
          return false;
        }
        return moment(value).isSameOrAfter(moment().add(10, 'minutes'));
      },
    ),
  expires_on: yup
    .string()
    .required('Expires on is required')
    .test(
      'min-30-minutes-after-scheduled',
      'Expiration must be at least 30 minutes after scheduled time',
      function (value) {
        const { scheduled_on } = this.parent;
        if (!value || !scheduled_on) {
          return false;
        }
        return moment(value).isSameOrAfter(moment(scheduled_on).add(30, 'minutes'));
      },
    ),
});
